module.exports = __webpack_public_path__ + "img/icon-calender.3e4b1e68.svg";